import { Fragment } from "react";
import { getETAnomalyTableColumns } from "../../../../utils/data";
import { VTEquipmentAnomalyData } from "../../../../utils/models";

import AutTable from "../../../blocks/aut-grid-table";
import ETAnomalyItemForm from "../../../forms/et/etAnomalyItemForm";

interface ETAnomalySummaryProps {
  anomalyData: VTEquipmentAnomalyData[];
  onDataChange: (items: VTEquipmentAnomalyData[]) => void;
}

const ETAnomalySummary = (props: ETAnomalySummaryProps) => {
  const onAddItem = (item: VTEquipmentAnomalyData) => {
    const newAnomalyData = [...props.anomalyData];
    newAnomalyData.push({ ...item, id: props.anomalyData.length + 1 });

    props.onDataChange(newAnomalyData);
  };

  const onDeleteItem = (item: VTEquipmentAnomalyData): void => {
    const newAnomalyData: VTEquipmentAnomalyData[] = props.anomalyData.filter(
      (i) => i.id !== item.id
    );
    props.onDataChange(newAnomalyData);
  };

  return (
    <Fragment>
      <ETAnomalyItemForm onAdd={onAddItem} />

      <div className="divider my-4"></div>

      <AutTable
        data={props.anomalyData}
        tableColumns={getETAnomalyTableColumns()}
        onDeleteItem={onDeleteItem}
      />
    </Fragment>
  );
};

export default ETAnomalySummary;
